function getEventTarget(e) {
	e = e || window.event;
	return e.target || e.srcElement;
}

var minusButtons = document.querySelectorAll('.js-button-minus');
var plusButtons = document.querySelectorAll('.js-button-plus');

[].forEach.call(minusButtons, function(minusButton) {
	minusButton.addEventListener('click', function(e) {
		e.preventDefault();
		e.stopPropagation();

		var target = getEventTarget(e);
		var fieldElementName = target.getAttribute('data-field');
		var elements = document.querySelectorAll('[name=' + fieldElementName + ']');

		[].forEach.call(elements, function(elem) {
			var currentValue = parseInt(elem.value, 10);

			if (!isNaN(currentValue) && currentValue > 0) {
				elem.value = currentValue - 1;
			} else {
				elem.value = 0;
			}
		});
	});
});

[].forEach.call(plusButtons, function(plusButton) {
	plusButton.addEventListener('click', function(e) {
		e.preventDefault();
		e.stopPropagation();

		var target = getEventTarget(e);
		var fieldElementName = target.getAttribute('data-field');
		var elements = document.querySelectorAll('[name=' + fieldElementName + ']');

		[].forEach.call(elements, function(elem) {
			var currentValue = parseInt(elem.value, 10);

			if (!isNaN(currentValue)) {
				elem.value = currentValue + 1;
			} else {
				elem.value = 0;
			}
		});
	});
});
